import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component that scrolls the window and main content area to the top
 * whenever the route changes.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll window to top
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    // Also scroll the main content area if it exists
    const mainElement = document.querySelector("main");
    if (mainElement) {
      mainElement.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }

    // Also handle any scrollable containers
    const scrollableContainers = document.querySelectorAll("[class*='overflow-y-auto'], [class*='overflow-auto']");
    scrollableContainers.forEach((container) => {
      if (container instanceof HTMLElement) {
        container.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;

